// SPDX-License-Identifier: MIT
export const __name__ = 'hdwallet';
export const __version__ = '1.0.0-beta.9';
export const __license__ = 'MIT';
export const __author__ = 'Meheret Tesfaye Batu';
export const __email__ = 'meherett.batu@gmail.com';
// export const __documentation__: string = '...';
export const __description__ = 'A complete Hierarchical Deterministic (HD) Wallet generator for 200+ cryptocurrencies, built with TypeScript.';
export const __url__ = 'https://hdwallet.io';
export const __source__ = 'https://github.com/hdwallet-io/hdwallet.js';
export const __changelog__ = `${__source__}/blob/master/CHANGELOG.md`;
export const __tracker__ = `${__source__}/issues`;
export const __keywords__ = [
    'ecc', 'kholaw', 'slip10', 'ed25519', 'nist256p1', 'secp256k1',
    'hd', 'bip32', 'bip44', 'bip49', 'bip84', 'bip86', 'bip141', 'monero', 'cardano',
    'entropy', 'mnemonic', 'seed', 'bip39', 'algorand', 'electrum',
    'cryptocurrencies', 'bitcoin', 'ethereum', 'cryptography', 'cli', 'cip1852'
];
export const __websites__ = [
    'https://talonlab.org',
    'https://talonlab.gitbook.io/hdwallet',
    // __documentation__,
    'https://hdwallet.online',
    'https://hd.wallet',
    __url__
];
//# sourceMappingURL=info.js.map